/**
 * Locale/i18n management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class LocaleManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async uploadLocale(file: File | Blob, params?: Record<string, any>): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post('/api/cdp/locale_i8n/upload', { data: formData, params, headers: {} });
  }

  async downloadTemplate(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/locale_i8n/downloadTemplate', {
      params,
      responseType: 'blob',
    });
  }

  async exportLocale(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/locale_i8n/export', {
      params,
      responseType: 'blob',
    });
  }
}
